export default {
	name: "Loader",
	props: {
		inline: Boolean,
		small: Boolean,
	},
};
